/* Rescuevation – easyToilet SOS, Familie rescu-etx (05.10.2026).

   Bewegung ist ADDITIV: Ohne JavaScript, bei reduzierter Bewegung und wenn ein
   Beobachter nie auslöst, steht jedes Element im fertigen Zustand. Dieses Script
   legt nur einmalige Keyframe-Läufe darüber (Klasse etx-go, nach 3 s wieder
   entfernt) und lässt die Stoppuhr der Minute einmal ablaufen.

   Kaufen: Ausführung + angehakte Mitbestell-Artikel gehen in einem Aufruf in den
   Warenkorb (/cart/add.js mit items); danach öffnet Dawns Schublade, ohne
   Schublade geht es auf die Warenkorbseite.

   Mehrere Sections laden diese Datei – der Guard sorgt dafür, dass sie nur
   einmal läuft (sonst landete eine Bestellung doppelt im Warenkorb). */
(function () {
  'use strict';
  if (window.__retx) return;
  window.__retx = true;

  var doc = document.documentElement;
  doc.classList.add('etx-js');

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var vh = function () { return window.innerHeight || doc.clientHeight; };
  var alle = function (wurzel, sel) { return Array.prototype.slice.call(wurzel.querySelectorAll(sel)); };
  var imBild = function (el) { var r = el.getBoundingClientRect(); return r.top < vh() - 40 && r.bottom > 0; };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var zahlFormat = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function euro(cent) { return zahlFormat.format(Math.round(cent) / 100) + ' €'; }
  function brutto(cent) { return Math.round(cent * 1.19); }

  /* ---------- einmalige Läufe ---------- */

  function einmal(el, klasse, dauer) {
    klasse = klasse || 'etx-go';
    var merker = '__etx_' + klasse;
    if (el[merker]) return;
    el[merker] = true;
    el.classList.add(klasse);
    setTimeout(function () { el.classList.remove(klasse); }, dauer || 3000);
  }

  function staffeln(liste) {
    var gruppen = new Map();
    liste.forEach(function (el) {
      var g = el.parentElement;
      var n = gruppen.get(g) || 0;
      if (!el.style.getPropertyValue('--etx-d')) el.style.setProperty('--etx-d', Math.min(n * 90, 450) + 'ms');
      gruppen.set(g, n + 1);
    });
  }

  function einblenden() {
    if (ruhig || !hatIO) return;
    var els = alle(document, '.etx [data-etx-in]');
    staffeln(els);
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        einmal(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) {
      /* Was beim Laden schon im Bild steht, bleibt ruhig */
      if (imBild(el)) return;
      io.observe(el);
    });

    /* Zeichnung: Konturen ziehen sich einmal nach */
    alle(document, '[data-etx-zeichnung]').forEach(function (el) {
      if (imBild(el)) return;
      var io2 = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return;
        io2.disconnect();
        einmal(el, 'etx-zeichnet', 3200);
      }, { rootMargin: '0px 0px -20% 0px' });
      io2.observe(el);
    });

    /* Puls der Anatomie-Punkte nur, solange die Zeichnung zu sehen ist */
    var io3 = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('etx-spielt', e.isIntersecting); });
    }, { threshold: 0.2 });
    alle(document, '[data-etx-zeichnung]').forEach(function (el) { io3.observe(el); });
  }

  /* ---------- Zahlen zählen einmal hoch ---------- */

  function hochzaehlen(el, ziel, dauer, verzoegerung) {
    var endText = el.textContent;
    var t0 = null;
    var schritt = function (t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dauer);
      var w = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      el.textContent = endText.replace(/[0-9]+/, String(Math.round(ziel * w)));
      if (p < 1) requestAnimationFrame(schritt); else el.textContent = endText;
    };
    setTimeout(function () { requestAnimationFrame(schritt); }, verzoegerung || 0);
  }

  function zaehlen() {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var ziel = parseFloat(String(e.target.getAttribute('data-etx-zahl')).replace(',', '.'));
        if (isNaN(ziel) || ziel <= 0 || ziel % 1 !== 0) return;
        hochzaehlen(e.target, ziel, 1400, 200);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    alle(document, '[data-etx-zahl]').forEach(function (el) { io.observe(el); });

    /* Stoppuhr im Kopf: Zahl läuft mit dem Ring (CSS: 0,5 s Verzug, 2,8 s) */
    alle(document, '[data-etx-uhr-zahl]').forEach(function (el) {
      var ziel = parseInt(el.textContent, 10);
      if (!ziel) return;
      hochzaehlen(el, ziel, 2800, 500);
    });
  }

  /* ---------- Galerie ---------- */

  function galerie() {
    alle(document, '[data-etx-galerie]').forEach(function (g) {
      var band = g.querySelector('[data-etx-band]');
      var minis = alle(g, '[data-etx-mini]');
      if (!band || !minis.length) return;
      var aktiv = function (i) { minis.forEach(function (m, k) { m.setAttribute('aria-current', k === i ? 'true' : 'false'); }); };
      minis.forEach(function (m, i) {
        m.addEventListener('click', function () {
          band.scrollTo({ left: band.clientWidth * i, behavior: ruhig ? 'auto' : 'smooth' });
          aktiv(i);
        });
      });
      var plan = false;
      band.addEventListener('scroll', function () {
        if (plan) return;
        plan = true;
        requestAnimationFrame(function () {
          plan = false;
          aktiv(Math.round(band.scrollLeft / Math.max(1, band.clientWidth)));
        });
      }, { passive: true });
    });
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) throw new Error(daten.description || daten.message || 'HTTP ' + res.status);
        return daten;
      });
    }).then(function (daten) {
      if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
        schublade.classList.remove('is-empty');
        schublade.renderContents(daten);
      } else {
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  function knopfLaeuft(btn, an) {
    if (!btn) return;
    if (an) {
      if (!btn.__etxLabel) btn.__etxLabel = btn.innerHTML;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (btn.__etxLabel) btn.innerHTML = btn.__etxLabel;
    }
  }

  function knopfOk(btn) {
    if (!btn) return;
    var label = btn.__etxLabel || btn.innerHTML;
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.classList.add('ist-ok');
    var text = btn.querySelector('[data-etx-submit-text]');
    if (text) text.textContent = 'Im Warenkorb';
    setTimeout(function () { btn.classList.remove('ist-ok'); btn.innerHTML = label; }, 2400);
  }

  function fehler(bereich, text) {
    var el = bereich.querySelector('[data-etx-fehler]');
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
  }

  function kauf() {
    alle(document, '[data-etx-kauf]').forEach(function (bereich) {
      var form = bereich.querySelector('[data-etx-form]');
      if (!form) return;
      var preisEl = bereich.querySelector('[data-etx-preis]');
      var bruttoEl = bereich.querySelector('[data-etx-brutto]');
      var summeEl = bereich.querySelector('[data-etx-summe]');
      var btn = form.querySelector('[data-etx-submit]');
      var btnText = form.querySelector('[data-etx-submit-text]');
      var kaufText = btnText ? btnText.textContent : 'In den Warenkorb';
      var anzahl = form.querySelector('[data-etx-anzahl]');
      var radios = alle(form, '[data-etx-variante]');
      var addons = alle(form, '[data-etx-addon]');

      var gewaehlt = function () { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; };

      /* Stepper */
      var st = form.querySelector('[data-etx-stepper]');
      if (st && anzahl) {
        var setzen = function (n) {
          n = Math.max(1, Math.min(50, isNaN(n) ? 1 : n));
          anzahl.value = n;
          rechnen();
        };
        st.querySelector('[data-etx-minus]').addEventListener('click', function () { setzen(parseInt(anzahl.value, 10) - 1); });
        st.querySelector('[data-etx-plus]').addEventListener('click', function () { setzen(parseInt(anzahl.value, 10) + 1); });
        anzahl.addEventListener('blur', function () { setzen(parseInt(anzahl.value, 10)); });
      }

      function rechnen() {
        var r = gewaehlt();
        if (!r) return;
        var p = parseInt(r.getAttribute('data-preis'), 10);
        var n = Math.max(1, parseInt(anzahl ? anzahl.value : 1, 10) || 1);
        if (preisEl && preisEl.textContent !== euro(p)) {
          preisEl.textContent = euro(p);
          if (!ruhig) { preisEl.classList.remove('etx-puls'); void preisEl.offsetWidth; preisEl.classList.add('etx-puls'); }
        }
        if (bruttoEl) bruttoEl.textContent = euro(brutto(p));
        var frei = r.getAttribute('data-verfuegbar') === 'true';
        if (btn) btn.disabled = !frei;
        if (btnText) btnText.textContent = frei ? kaufText : 'Ausverkauft';

        var extra = 0, namen = [];
        addons.forEach(function (a) {
          if (a.checked) { extra += parseInt(a.getAttribute('data-preis'), 10); namen.push(a.getAttribute('data-titel')); }
        });
        if (summeEl) {
          if (extra > 0 || n > 1) {
            var netto = p * n + extra;
            summeEl.hidden = false;
            summeEl.innerHTML = 'Summe' + (n > 1 ? ' für ' + n + ' Stück' : '') + (namen.length ? ', dazu ' + namen.join(' und ') : '') +
              ': <strong>' + euro(netto) + '</strong> netto · ' + euro(brutto(netto)) + ' inkl. MwSt.';
          } else {
            summeEl.hidden = true;
          }
        }
        document.dispatchEvent(new CustomEvent('etx:variante', { detail: { preisCent: p } }));
        /* Sticky-Leiste (rescu-bl-sticky) mitziehen */
        alle(document, '[data-bl-sticky-preis]').forEach(function (t) { t.textContent = euro(p); });
        alle(document, '[data-bl-sticky-kauf]').forEach(function (k) { k.hidden = !frei; });
      }

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          rechnen();
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', r.value);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* egal */ }
        });
      });
      addons.forEach(function (a) { a.addEventListener('change', rechnen); });
      if (anzahl) { anzahl.addEventListener('change', rechnen); anzahl.addEventListener('input', rechnen); }
      rechnen();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var r = gewaehlt();
        if (!r || r.getAttribute('data-verfuegbar') !== 'true') return;
        if (btn && btn.hasAttribute('aria-busy')) return;
        var items = [{ id: parseInt(r.value, 10), quantity: Math.max(1, parseInt(anzahl ? anzahl.value : 1, 10) || 1) }];
        addons.forEach(function (a) { if (a.checked) items.push({ id: parseInt(a.value, 10), quantity: 1 }); });
        fehler(bereich, '');
        knopfLaeuft(btn, true);
        inDenWarenkorb(items).then(function () {
          knopfOk(btn);
        }).catch(function (err) {
          knopfLaeuft(btn, false);
          fehler(bereich, 'Das hat nicht geklappt: ' + err.message + '. Bitte versuche es noch einmal oder ruf uns an.');
        });
      });
    });
  }

  /* ---------- Die Minute ---------- */

  function minute() {
    alle(document, '[data-etx-minute]').forEach(function (sec) {
      var ring = sec.querySelector('[data-etx-ring]');
      var zeiger = sec.querySelector('[data-etx-zeiger]');
      var zahl = sec.querySelector('[data-etx-sekunde]');
      var knopf = sec.querySelector('[data-etx-nochmal]');
      var uhr = sec.querySelector('.etx-minute__uhr');
      var schritte = alle(sec, '[data-etx-schritt]');
      var uhrtext = sec.querySelector('[data-etx-uhrtext]');
      var ruheText = uhrtext ? uhrtext.textContent : '';
      var dauer = Math.max(3, parseFloat(sec.getAttribute('data-dauer')) || 6) * 1000;
      var laeuft = false;
      if (!ring || !uhr || ruhig) return;

      function stand(sek) {
        ring.style.strokeDashoffset = String(60 - sek);
        if (zeiger) zeiger.style.transform = 'rotate(' + (sek * 6) + 'deg)';
        if (zahl) zahl.textContent = String(Math.floor(sek));
        var dran = -1;
        schritte.forEach(function (s, i) { if (sek >= (parseFloat(s.getAttribute('data-sekunde')) || 0)) dran = i; });
        schritte.forEach(function (s, i) {
          s.classList.toggle('ist-dran', i === dran);
          s.classList.toggle('ist-fertig', i < dran);
        });
      }

      function aufraeumen() {
        sec.classList.remove('etx-spielt');
        ring.style.strokeDashoffset = '';
        if (zeiger) zeiger.style.transform = '';
        if (zahl) zahl.textContent = '60';
        if (uhrtext) uhrtext.textContent = ruheText;
        schritte.forEach(function (s) { s.classList.remove('ist-dran', 'ist-fertig'); });
        laeuft = false;
        if (knopf) knopf.hidden = false;
      }

      function spielen() {
        if (laeuft) return;
        laeuft = true;
        sec.classList.add('etx-spielt');
        if (uhrtext && uhrtext.getAttribute('data-laeuft')) uhrtext.textContent = uhrtext.getAttribute('data-laeuft');
        var t0 = null;
        var schritt = function (t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dauer);
          stand(60 * p);
          if (p < 1) requestAnimationFrame(schritt);
          else setTimeout(aufraeumen, 900);
        };
        requestAnimationFrame(schritt);
      }

      if (knopf) knopf.addEventListener('click', spielen);

      if (!hatIO) { if (knopf) knopf.hidden = false; return; }
      var io = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return;
        io.disconnect();
        spielen();
      }, { threshold: 0.6 });
      io.observe(uhr);
    });
  }

  /* ---------- Anatomie: Punkt und Legende koppeln ---------- */

  function anatomie() {
    alle(document, '[data-etx-anatomie]').forEach(function (sec) {
      var punkte = alle(sec, '[data-etx-punkt]');
      var eintraege = alle(sec, '[data-etx-eintrag]');
      var fest = null;
      function zeige(nr) {
        punkte.forEach(function (p) { p.setAttribute('aria-pressed', p.getAttribute('data-etx-punkt') === nr ? 'true' : 'false'); });
        eintraege.forEach(function (e) { e.classList.toggle('ist-aktiv', e.getAttribute('data-etx-eintrag') === nr); });
      }
      punkte.forEach(function (p) {
        var nr = p.getAttribute('data-etx-punkt');
        p.addEventListener('click', function () {
          fest = fest === nr ? null : nr;
          zeige(fest);
          if (fest && window.innerWidth < 990) {
            var ziel = sec.querySelector('[data-etx-eintrag="' + nr + '"]');
            if (ziel && !imBild(ziel)) ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' });
          }
        });
        p.addEventListener('mouseenter', function () { zeige(nr); });
        p.addEventListener('mouseleave', function () { zeige(fest); });
        p.addEventListener('focus', function () { zeige(nr); });
        p.addEventListener('blur', function () { zeige(fest); });
      });
      eintraege.forEach(function (e) {
        var nr = e.getAttribute('data-etx-eintrag');
        e.addEventListener('mouseenter', function () { zeige(nr); });
        e.addEventListener('mouseleave', function () { zeige(fest); });
      });
    });
  }

  /* ---------- Ausbaustufen: Weiche ---------- */

  function weiche() {
    alle(document, '[data-etx-stufen]').forEach(function (sec) {
      var reiter = alle(sec, '[data-etx-reiter]');
      var reihe = sec.querySelector('[data-etx-reihe]');
      var karten = alle(sec, '[data-etx-karte]');
      if (!reiter.length) return;
      function waehle(nr, schieben) {
        sec.setAttribute('data-gewaehlt', nr);
        karten.forEach(function (k) {
          var an = k.getAttribute('data-etx-karte') === nr;
          k.classList.toggle('ist-gewaehlt', an);
          var b = k.querySelector('[data-etx-karten-knopf]');
          if (b) {
            b.classList.toggle('etx-btn--kauf', an || k.classList.contains('ist-empfohlen'));
            b.classList.toggle('etx-btn--kontur', !(an || k.classList.contains('ist-empfohlen')));
          }
          if (an && schieben && reihe && reihe.scrollWidth > reihe.clientWidth + 4) {
            reihe.scrollTo({ left: k.offsetLeft - reihe.offsetLeft - 16, behavior: ruhig ? 'auto' : 'smooth' });
          }
        });
      }
      reiter.forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) waehle(r.value, true); });
      });
    });
  }


  /* ---------- Kaufen statt mieten ---------- */

  function rechner() {
    var ganz = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
    alle(document, '[data-etx-rechner]').forEach(function (r) {
      var preis = parseInt(r.getAttribute('data-preis'), 10) || 0;
      var horizont = parseInt(r.getAttribute('data-horizont'), 10) || 5;
      var miete = r.querySelector('[data-etx-miete]');
      var einsaetze = r.querySelector('[data-etx-einsaetze]');
      var q = function (sel) { return r.querySelector(sel); };
      function rechne() {
        var m = (parseInt(miete.value, 10) || 140) * 100;
        var e = parseInt(einsaetze.value, 10) || 1;
        q('[data-etx-out-miete]').textContent = ganz.format(m / 100) + ' €';
        q('[data-etx-out-einsaetze]').textContent = String(e);
        var anl = Math.ceil(preis / m);
        var jahre = anl / e;
        var text;
        if (jahre < 1) {
          var monate = Math.max(1, Math.round(jahre * 12));
          text = monate + (monate === 1 ? ' Monat' : ' Monaten');
        } else {
          var g = Math.round(jahre * 10) / 10;
          text = g.toLocaleString('de-DE', { maximumFractionDigits: 1 }) + (g === 1 ? ' Jahr' : ' Jahren');
        }
        q('[data-etx-ergebnis]').textContent = text;
        q('[data-etx-zusatz]').textContent = anl + ' eingesparte Anlieferungen. Danach kostet jeder weitere Einsatz nur noch den Hygienebeutel.';
        q('[data-etx-weg]').textContent = 'Rechenweg: ' + euro(preis) + ' netto ÷ ' + euro(m) + ' je Anlieferung = ' + anl + ' Anlieferungen, bei ' + e + (e === 1 ? ' Einsatz' : ' Einsätzen') + ' im Jahr.';
        var mg = m * e * horizont;
        var gr = Math.max(mg, preis);
        q('[data-etx-bar-kauf]').style.width = Math.max(3, preis / gr * 100).toFixed(1) + '%';
        q('[data-etx-bar-miete]').style.width = Math.max(3, mg / gr * 100).toFixed(1) + '%';
        q('[data-etx-wert-kauf]').textContent = euro(preis);
        q('[data-etx-wert-miete]').textContent = euro(mg);
        var d = mg - preis;
        var diff = q('[data-etx-diff]');
        diff.textContent = d > 0 ? 'Ersparnis nach ' + horizont + ' Jahren: ' + euro(d) : 'In diesem Zeitraum liegt die Miete noch unter dem Kaufpreis.';
        diff.classList.toggle('ist-plus', d > 0);
      }
      if (!miete || !einsaetze) return;
      r.addEventListener('input', rechne);
      document.addEventListener('etx:variante', function (ev) {
        if (ev.detail && ev.detail.preisCent) { preis = ev.detail.preisCent; rechne(); }
      });
      rechne();
    });
  }

  function start() {
    einblenden();
    zaehlen();
    galerie();
    rechner();
    kauf();
    minute();
    anatomie();
    weiche();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
